import { FiltersWithModalInputSelectField, InputWrapper } from '@presentation/components';
import { useTranslation } from '@presentation/utils';
import { Form } from 'formik';
import type { FC } from 'react';
import type { FiltersProps } from './types';

export const Filters: FC<FiltersProps> = (props) => {
  const { categoryTags } = props;
  const { translate } = useTranslation();

  return (
    <Form>
      <InputWrapper width="250px" fullWidthBreakpoint="phone">
        <FiltersWithModalInputSelectField<string>
          name="tagId"
          useSearch={false}
          placeholder={translate('common.inputs.categories.placeholder')}
          options={categoryTags}
        />
      </InputWrapper>
    </Form>
  );
};
